module.exports = __webpack_public_path__ + "static/media/marina_marker_light_blue.a5ce2336.svg";